/**
 * Umami Analytics Service
 * Lädt das Tracking-Script nur bei ausdrücklicher Nutzereinwilligung.
 */

const SCRIPT_ID = 'umami-analytics-script';

const UMAMI_SCRIPT_URL = 'https://umami.bydns.de/script.js';
const UMAMI_WEBSITE_ID = '73946578-ca26-44f9-ad26-30215ad5b42f';

export function isUmamiConfigured() {
  return !!(UMAMI_SCRIPT_URL && UMAMI_WEBSITE_ID);
}

export function isUmamiActive() {
  return !!document.getElementById(SCRIPT_ID);
}

export function enableUmami() {
  if (!isUmamiConfigured() || isUmamiActive()) return;

  const script = document.createElement('script');
  script.id = SCRIPT_ID;
  script.defer = true;
  script.src = UMAMI_SCRIPT_URL;
  script.setAttribute('data-website-id', UMAMI_WEBSITE_ID);
  document.head.appendChild(script);
}

export function disableUmami() {
  const script = document.getElementById(SCRIPT_ID);
  if (script) script.remove();
}

export function applyAnalyticsConsent(consent, globallyEnabled = true) {
  if (!isUmamiConfigured() || !globallyEnabled) {
    disableUmami();
    return;
  }

  if (consent === true) {
    enableUmami();
  } else {
    disableUmami();
  }
}
